import React from "react";
import CallToActionButton from "../components/callToActionButton";
import { useTranslation } from 'gatsby-plugin-react-i18next';

const BannerContact = () => {
  const { t } = useTranslation();

  return (
    <div className="banner-contact">
      <h3 style={{ marginBottom: '2rem' }}>{t("banner-contact-title")}</h3>
      <CallToActionButton 
        text={t("banner-contact-button")}
        color="#9340ff"
      />
    </div>
  );
}

export default BannerContact;